import { API } from "@/lib/api";

/**
 * Scans a plain-text meal item string, finds known dish keywords, and returns
 * an array of segments: [{text}] or [{text, slug, name}].
 * Longest keyword wins — "moong-sprout chilla" matches before "chilla".
 */
export function linkifyMealItem(text, index) {
  if (!text || !index) return [{ text }];
  const lower = text.toLowerCase();
  // Longest keywords first
  const keywords = Object.keys(index).sort((a, b) => b.length - a.length);
  const matches = [];
  for (const kw of keywords) {
    let searchFrom = 0;
    while (true) {
      const idx = lower.indexOf(kw, searchFrom);
      if (idx === -1) break;
      // Ensure word-ish boundary (so "chilla" doesn't match inside "chillado")
      const before = idx === 0 ? " " : lower[idx - 1];
      const after = idx + kw.length >= lower.length ? " " : lower[idx + kw.length];
      const isBoundary = /[^a-z0-9]/i.test(before) && /[^a-z0-9]/i.test(after);
      if (isBoundary) {
        // Skip if overlaps an existing match
        const overlap = matches.some(
          (m) => (idx >= m.start && idx < m.end) || (idx + kw.length > m.start && idx + kw.length <= m.end)
        );
        if (!overlap) {
          matches.push({ start: idx, end: idx + kw.length, slug: index[kw].slug, name: index[kw].name });
        }
      }
      searchFrom = idx + kw.length;
    }
  }
  if (!matches.length) return [{ text }];
  matches.sort((a, b) => a.start - b.start);
  const out = [];
  let cursor = 0;
  for (const m of matches) {
    if (m.start > cursor) out.push({ text: text.slice(cursor, m.start) });
    out.push({ text: text.slice(m.start, m.end), slug: m.slug, name: m.name });
    cursor = m.end;
  }
  if (cursor < text.length) out.push({ text: text.slice(cursor) });
  return out;
}

export function recipeUrl(slug) {
  return `/recipes/${slug}`;
}

let _indexCache = null;
export async function fetchRecipeIndex() {
  if (_indexCache) return _indexCache;
  try {
    const res = await fetch(`${API}/recipes-index`);
    _indexCache = await res.json();
    return _indexCache;
  } catch {
    return {};
  }
}
